export function DefaultFieldsInfo() {
  return (
    <div
      style={{
        padding: '1rem 1.25rem',
        background: 'linear-gradient(135deg, rgba(142,11,86,0.05) 0%, rgba(142,11,86,0.02) 100%)',
        border: '1px solid rgba(142,11,86,0.1)',
        borderRadius: '12px',
      }}
    >
      <h3
        style={{
          fontSize: '0.95rem',
          fontWeight: 600,
          color: '#8E0B56',
          marginBottom: '0.5rem',
        }}
      >
        Champs obligatoires par défaut
      </h3>
      <p style={{ fontSize: '0.85rem', color: '#4a042c', marginBottom: '0.75rem' }}>
        Ces champs sont toujours présents dans le formulaire de réservation :
      </p>
      <ul style={{ fontSize: '0.85rem', color: '#4a042c', margin: 0, paddingLeft: '1.5rem' }}>
        <li>Prénom</li>
        <li>Nom</li>
        <li>Email</li>
        <li>Téléphone</li>
      </ul>
    </div>
  );
}
